module.exports = __webpack_public_path__ + "static/media/5.b21762b3.jpg";